import { observable, makeObservable, action } from 'mobx'

export class SimpleObservableValue<T> {
  @observable
  value: T

  constructor(value: T) {
    this.value = value
    makeObservable(this)
  }

  @action
  setValue(value: T | ((current: T) => T)) {
    this.value =
      typeof value === 'function'
        ? (value as (current: T) => T)(this.value)
        : value
  }
}
